import { render, staticRenderFns } from "./TeamCreate.vue?vue&type=template&id=6ddab55e&"
import script from "./TeamCreate.vue?vue&type=script&lang=js&"
export * from "./TeamCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports